// Planificador de projetos Navita — secção "navita-planificador" do tema Dwell.
// Lógica igual à do protótipo (Planificador/prototipo); aqui os preços, o stock, os títulos e as imagens
// vêm ao vivo da loja (JSON escrito pela secção em Liquid) e os atributos dos fios vêm de
// navita-planificador-dados.js (gerado a partir das folhas revistas pela equipa).

/* ---------- textos (o site tem PT na raiz, ES em /es e EN em /en) ---------- */
const T = {
 pt:{step:"Passo {n} de {t}", next:"Continuar", back:"Voltar", moreOpts:"Ver mais opções", skip:"Não sei / avançar",
  unsure:"Ainda não sei", restart:"Recomeçar", edit:"Alterar respostas", loadErr:"Não conseguimos abrir o planificador. Atualiza a página ou fala connosco.",
  q:{tecnica:["Que técnica vais usar?","Escolhe a técnica do teu projeto."],
     peca:["O que queres fazer?","Escolhe a peça mais parecida com o teu projeto."],
     uso:["Onde vai ficar a peça?","Para o exterior sugerimos só fios impermeáveis e com proteção UV."],
     caracts:["Que características procuras?","Podes escolher várias, ou avançar sem escolher."],
     material:["Tens preferência de material?",""],
     esp:["Que espessura procuras?","Se seguires um tutorial, a espessura costuma vir indicada."],
     cores:["Que cores tens em mente?","Podes escolher várias."],
     nivel:["Qual é a tua experiência?","Ajuda-nos a sugerir também um kit, se fizer sentido."]},
  resTitle:"As nossas sugestões para ti", resSub:"Escolhe a espessura e a cor e junta ao carrinho.",
  relaxed:"Não encontrámos um fio com todas as tuas escolhas, por isso ignorámos: {x}.",
  nores:"Não encontrámos nenhum fio para estas respostas. Experimenta alterar algumas.",
  why:{pref:"Sugestão da Navita para este projeto", peca:"Indicado para {x}", ext:"Próprio para exterior", esp:"Disponível em {x}", espNear:"Espessura mais próxima: {x}", espRec:"Espessura recomendada: {x}", cores:"{n} cores na família que escolheste", cores1:"1 cor na família que escolheste"},
  esp:"Espessura", fmt:"Bobine", color:"Cor", seeAll:"Ver todas as cores ({n})", seeLess:"Mostrar só as cores escolhidas",
  perBob:"{m} m por bobine", perM:"{p}/m", meters:"Precisas de quantos metros?", metersHint:"Calculamos as bobines com 10% de margem.",
  bobines:"bobines", add:"Adicionar ao carrinho", adding:"A adicionar…", added:"Adicionado ✓", addErr:"Não foi possível adicionar ao carrinho.",
  view:"Ver produto", more:"Ver mais sugestões", oppTxt:"Oportunidade",
  oppMsg:"{t} por {p} (stock limitado)", kitsTitle:"Estás a começar? Experimenta um kit", kitBtn:"Ver kit", from:"desde",
  calc:"Em breve: calculadora de metros por peça e tamanho.",
  leadTitle:"Recebe o teu plano por e-mail", leadSub:"Enviamos-te estas sugestões para as teres à mão quando fores comprar.",
  leadPh:"O teu e-mail", leadBtn:"Enviar-me o plano", consent:"Quero receber o meu plano e e-mails da Navita com novidades, ideias e promoções. Posso cancelar a qualquer momento.", privacy:"Política de Privacidade",
  errEmail:"Escreve um e-mail válido.", errConsent:"Para te enviarmos o plano, marca a caixa de consentimento.", errSend:"Não conseguimos enviar agora. Tenta de novo daqui a pouco ou fala connosco.", leadOk:"Feito! O teu plano vai a caminho de {e}.",
  leadTest:"Modo de teste: o envio para o Klaviyo está desligado nas definições da secção, por isso nada foi enviado. Ver os dados que seriam guardados",
  helpTitle:"Ficaste com dúvidas ou queres algo em específico?", helpSub:"Fala connosco — ajudamos-te a escolher.",
  waIntro:"Olá Navita! Usei o planificador de projetos.", waAns:"As minhas respostas: {x}", waSug:"Sugestões que recebi:", waQ:"A minha dúvida:", mailSubj:"Dúvida sobre o meu projeto (planificador)",
  recSub:"Para {peca} em {tec}, costuma usar-se fio de {r}. Se não tiveres a certeza, escolhe a opção recomendada.", recSubTec:"Em {tec}, costuma usar-se fio de {r}. Se não tiveres a certeza, escolhe a opção recomendada.", recBadge:"Recomendado", inRange:"Indicado",
  recBox:"Espessura recomendada para o teu projeto: {d} (entre {r}).", recDiff:"Escolheste {x}. Para este projeto costuma usar-se {r} — confirma no teu tutorial.",
  hook:"Agulha de croché recomendada: {r}", addHook:"Juntar agulha de {x} ({p})",
  ans:{tecnica:"Técnica",peca:"Peça",uso:"Uso",caracts:"Características",material:"Material",esp:"Espessura",cores:"Cores",nivel:"Nível"}},
 es:{step:"Paso {n} de {t}", next:"Continuar", back:"Volver", moreOpts:"Ver más opciones", skip:"No lo sé / seguir",
  unsure:"Aún no lo sé", restart:"Empezar de nuevo", edit:"Cambiar respuestas", loadErr:"No hemos podido abrir el planificador. Actualiza la página o habla con nosotros.",
  q:{tecnica:["¿Qué técnica vas a usar?","Elige la técnica de tu proyecto."],
     peca:["¿Qué quieres hacer?","Elige la pieza más parecida a tu proyecto."],
     uso:["¿Dónde estará la pieza?","Para exterior sugerimos solo hilos impermeables y con protección UV."],
     caracts:["¿Qué características buscas?","Puedes elegir varias, o seguir sin elegir."],
     material:["¿Prefieres algún material?",""],
     esp:["¿Qué grosor buscas?","Si sigues un tutorial, suele indicar el grosor."],
     cores:["¿Qué colores tienes en mente?","Puedes elegir varios."],
     nivel:["¿Cuál es tu experiencia?","Así también te sugerimos un kit, si tiene sentido."]},
  resTitle:"Nuestras sugerencias para ti", resSub:"Elige el grosor y el color y añádelo al carrito.",
  relaxed:"No encontramos un hilo con todas tus elecciones, así que hemos ignorado: {x}.",
  nores:"No encontramos ningún hilo para estas respuestas. Prueba a cambiar alguna.",
  why:{pref:"Sugerencia de Navita para este proyecto", peca:"Indicado para {x}", ext:"Apto para exterior", esp:"Disponible en {x}", espNear:"Grosor más cercano: {x}", espRec:"Grosor recomendado: {x}", cores:"{n} colores en la familia elegida", cores1:"1 color en la familia elegida"},
  esp:"Grosor", fmt:"Bobina", color:"Color", seeAll:"Ver todos los colores ({n})", seeLess:"Mostrar solo los colores elegidos",
  perBob:"{m} m por bobina", perM:"{p}/m", meters:"¿Cuántos metros necesitas?", metersHint:"Calculamos las bobinas con un 10% de margen.",
  bobines:"bobinas", add:"Añadir al carrito", adding:"Añadiendo…", added:"Añadido ✓", addErr:"No se ha podido añadir al carrito.",
  view:"Ver producto", more:"Ver más sugerencias", oppTxt:"Oportunidad",
  oppMsg:"{t} por {p} (stock limitado)", kitsTitle:"¿Estás empezando? Prueba un kit", kitBtn:"Ver kit", from:"desde",
  calc:"Próximamente: calculadora de metros por pieza y tamaño.",
  leadTitle:"Recibe tu plan por e-mail", leadSub:"Te enviamos estas sugerencias para tenerlas a mano cuando compres.",
  leadPh:"Tu e-mail", leadBtn:"Enviarme el plan", consent:"Quiero recibir mi plan y e-mails de Navita con novedades, ideas y promociones. Puedo darme de baja en cualquier momento.", privacy:"Política de Privacidad",
  errEmail:"Escribe un e-mail válido.", errConsent:"Para enviarte el plan, marca la casilla de consentimiento.", errSend:"No hemos podido enviarlo ahora. Inténtalo de nuevo en un momento o habla con nosotros.", leadOk:"¡Hecho! Tu plan va de camino a {e}.",
  leadTest:"Modo de prueba: el envío a Klaviyo está desactivado en los ajustes de la sección, así que no se ha enviado nada. Ver los datos que se guardarían",
  helpTitle:"¿Tienes dudas o buscas algo concreto?", helpSub:"Habla con nosotros — te ayudamos a elegir.",
  waIntro:"¡Hola Navita! He usado el planificador de proyectos.", waAns:"Mis respuestas: {x}", waSug:"Sugerencias que recibí:", waQ:"Mi duda:", mailSubj:"Duda sobre mi proyecto (planificador)",
  recSub:"Para {peca} en {tec}, se suele usar hilo de {r}. Si no estás segura, elige la opción recomendada.", recSubTec:"En {tec}, se suele usar hilo de {r}. Si no estás segura, elige la opción recomendada.", recBadge:"Recomendado", inRange:"Indicado",
  recBox:"Grosor recomendado para tu proyecto: {d} (entre {r}).", recDiff:"Has elegido {x}. Para este proyecto se suele usar {r} — compruébalo en tu tutorial.",
  hook:"Aguja de ganchillo recomendada: {r}", addHook:"Añadir aguja de {x} ({p})",
  ans:{tecnica:"Técnica",peca:"Pieza",uso:"Uso",caracts:"Características",material:"Material",esp:"Grosor",cores:"Colores",nivel:"Nivel"}},
 en:{step:"Step {n} of {t}", next:"Continue", back:"Back", moreOpts:"See more options", skip:"Not sure / skip",
  unsure:"I'm not sure yet", restart:"Start over", edit:"Change answers", loadErr:"We couldn't open the planner. Refresh the page or get in touch.",
  q:{tecnica:["Which technique will you use?","Choose the technique for your project."],
     peca:["What do you want to make?","Choose the piece closest to your project."],
     uso:["Where will the piece live?","For outdoors we only suggest waterproof, UV-protected cords."],
     caracts:["What are you looking for?","You can choose several, or skip."],
     material:["Any material preference?",""],
     esp:["Which thickness are you after?","If you're following a tutorial, it usually tells you the thickness."],
     cores:["Which colours do you have in mind?","You can choose several."],
     nivel:["How experienced are you?","It helps us suggest a kit too, if it makes sense."]},
  resTitle:"Our suggestions for you", resSub:"Choose the thickness and colour and add to cart.",
  relaxed:"We couldn't find a cord that matches all your choices, so we left out: {x}.",
  nores:"We couldn't find a cord for these answers. Try changing some of them.",
  why:{pref:"Navita's pick for this project", peca:"Suits {x}", ext:"Made for outdoors", esp:"Available in {x}", espNear:"Closest thickness: {x}", espRec:"Recommended thickness: {x}", cores:"{n} colours in the family you chose", cores1:"1 colour in the family you chose"},
  esp:"Thickness", fmt:"Spool", color:"Colour", seeAll:"See all colours ({n})", seeLess:"Show only the colours you chose",
  perBob:"{m} m per spool", perM:"{p}/m", meters:"How many metres do you need?", metersHint:"We work out the spools with a 10% margin.",
  bobines:"spools", add:"Add to cart", adding:"Adding…", added:"Added ✓", addErr:"We couldn't add this to your cart.",
  view:"View product", more:"See more suggestions", oppTxt:"Opportunity",
  oppMsg:"{t} for {p} (limited stock)", kitsTitle:"Just starting out? Try a kit", kitBtn:"View kit", from:"from",
  calc:"Coming soon: a metre calculator by piece and size.",
  leadTitle:"Get your plan by email", leadSub:"We'll send you these suggestions so you have them handy when you shop.",
  leadPh:"Your email", leadBtn:"Send me the plan", consent:"I want to receive my plan and emails from Navita with news, ideas and offers. I can unsubscribe at any time.", privacy:"Privacy Policy",
  errEmail:"Please enter a valid email.", errConsent:"To send you the plan, tick the consent box.", errSend:"We couldn't send it right now. Try again in a moment or get in touch.", leadOk:"Done! Your plan is on its way to {e}.",
  leadTest:"Test mode: sending to Klaviyo is turned off in the section settings, so nothing was sent. See the data that would be saved",
  helpTitle:"Still have questions or looking for something specific?", helpSub:"Talk to us — we'll help you choose.",
  waIntro:"Hi Navita! I used the project planner.", waAns:"My answers: {x}", waSug:"Suggestions I got:", waQ:"My question:", mailSubj:"Question about my project (planner)",
  recSub:"For {peca} in {tec}, people usually use {r} cord. If you're not sure, pick the recommended option.", recSubTec:"In {tec}, people usually use {r} cord. If you're not sure, pick the recommended option.", recBadge:"Recommended", inRange:"Suitable",
  recBox:"Recommended thickness for your project: {d} (between {r}).", recDiff:"You chose {x}. This project usually calls for {r} — check your tutorial.",
  hook:"Recommended crochet hook: {r}", addHook:"Add a {x} hook ({p})",
  ans:{tecnica:"Technique",peca:"Piece",uso:"Use",caracts:"Features",material:"Material",esp:"Thickness",cores:"Colours",nivel:"Level"}}
};
// Famílias de cor. As palavras-chave são PT (os nomes PT das cores chegam pela posição da opção);
// as ES ficam como reserva, para cores novas que ainda não estejam em navita-planificador-dados.js.
const FAM = {
 branco:{pt:"Branco",es:"Blanco",en:"White",c:"#FFFFFF",k:["branco","branca","blanco","blanca"]},
 natural:{pt:"Cru / Natural",es:"Crudo / Natural",en:"Cream / Natural",c:"#E9DFC9",k:["natural","cru","creme","perola","areia","bege","nude","champagne","palha","juta","linho","crudo","crema","arena","beige","perla","lino","yute"]},
 castanho:{pt:"Castanho",es:"Marrón",en:"Brown",c:"#8A5A3B",k:["castanho","camel","caramelo","terra","moca","mocha","chocolate","canela","carvalho","bronze","taupe","marrom","marron","castano","camello","roble","topo"]},
 amarelo:{pt:"Amarelo",es:"Amarillo",en:"Yellow",c:"#E2B53E",k:["amarelo","mostarda","manteiga","amarillo","mostaza","mantequilla"]},
 laranja:{pt:"Laranja / Terracota",es:"Naranja / Terracota",en:"Orange / Terracotta",c:"#D9774A",k:["laranja","terracota","terracotta","apricot","pessego","salmao","coral","labareda","ambar","phoenix","naranja","melocoton","salmon"]},
 vermelho:{pt:"Vermelho",es:"Rojo",en:"Red",c:"#B23A3A",k:["vermelho","ginja","bordeaux","cereja","framboesa","ruby","rojo","cereza","frambuesa","burdeos"]},
 rosa:{pt:"Rosa",es:"Rosa",en:"Pink",c:"#E59AB4",k:["rosa","fucsia","pink","blush","barbie","bombom"]},
 roxo:{pt:"Roxo / Lilás",es:"Morado / Lila",en:"Purple / Lilac",c:"#8C6BB1",k:["roxo","lavanda","violeta","berinjela","lilas","morado","lila","berenjena"]},
 azul:{pt:"Azul",es:"Azul",en:"Blue",c:"#3D6FB6",k:["azul","marinho","petroleo","celeste","ganga","royal","oceano","fjord","capri","cobalto","turquesa","navy","marino","vaquero","fiordo"]},
 verde:{pt:"Verde",es:"Verde",en:"Green",c:"#5E8C5A",k:["verde","eucalipto","azeitona","militar","caqui","lima","salvia","esmeralda","floresta","emerald","oliva","bosque"]},
 cinza:{pt:"Cinza",es:"Gris",en:"Grey",c:"#9A9A9A",k:["cinza","cinzento","grafite","granito","stone","gris","grafito","piedra","ceniza"]},
 preto:{pt:"Preto",es:"Negro",en:"Black",c:"#1D1D1D",k:["preto","eclipse","negro","negra"]},
 metal:{pt:"Dourado / Prateado",es:"Dorado / Plateado",en:"Gold / Silver",c:"linear-gradient(135deg,#E8C979,#B8955E 45%,#D9D9D9 55%,#9E9E9E)",k:["ouro","prata","cobre","lurex","shine","metalico","glam","aurum","silver","gold","cristal","brilhante","oro","plata","dorado","plateado"]},
 mix:{pt:"Multicolor",es:"Multicolor",en:"Multicolour",c:"conic-gradient(#D9774A,#E2B53E,#5E8C5A,#3D6FB6,#8C6BB1,#D9774A)",k:["mix","trio","matizado","multicolor","mesclado","tricolor","bicolor"]}
};
const MATS = [
 ["Sintético", f=>/sint[eé]tic|nylon|cetim|poli[eé]ster/i.test(f.material)],
 ["Algodão", f=>/algod/i.test(f.material)],
 ["Juta", f=>/juta/i.test(f.material)],
 ["Linho", f=>/linho/i.test(f.material)],
 ["Lã", f=>/\blã\b|merino/i.test(f.material)],
 ["Papel", f=>/papel/i.test(f.material)],
 ["Metálico", f=>f.familia==="Metálico"||/met[aá]lic|lurex|metaliz/i.test(f.material)],
 ["Bambu", f=>/bambu/i.test(f.material)],
 ["Cânhamo", f=>/c[aâ]nhamo/i.test(f.material)]
];
const ORDER = ["tecnica","peca","uso","caracts","material","esp","cores","nivel"];
const MULTI = {caracts:1, cores:1};
const UNSURE = "?";
const WHATSAPP = "351915011990", EMAIL = "geral@navita.pt";
// Klaviyo: chave pública da conta + lista "Planificador de Projetos". O envio liga-se nas definições da secção.
const KLAVIYO = {empresa: "RSiHay", lista: "TdUyu7", revisao: "2024-10-15", fonte: "Planificador de Projetos"};

const fmt = (s, o) => s.replace(/\{(\w+)\}/g, (_,k)=>o[k]);
const norm = s => (s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").toLowerCase();
const mm = s => parseFloat(String(s||"").replace(",", "."));
const esc = s => String(s??"").replace(/[&<>"]/g, c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const abs = u => !u ? null : (u.startsWith("//") ? "https:" + u : u);
function normMm(s){                    // "2,5mm", "1.5 mm", "Nº3" -> "2.5mm", "1.5mm", "3mm"
  s = String(s||"").replace(",", ".").toLowerCase().replace(/\s/g, "");
  let m = s.match(/(\d+(?:\.\d+)?)mm/); if (m) return m[1] + "mm";
  m = s.match(/^nº(\d)/); return m ? m[1] + "mm" : null;
}

document.querySelectorAll("[data-navita-planificador]").forEach(root => {
  iniciar(root).catch(e => {
    console.error("Planificador:", e);
    const app = root.querySelector("[data-np-app]");
    if (app) app.innerHTML = `<p class="np-empty">${esc((T[root.dataset.lang]||T.pt).loadErr)}</p>`;
  });
});

async function iniciar(root){
const lang = T[root.dataset.lang] ? root.dataset.lang : "pt";
const ROOT = (root.dataset.root || "/").replace(/\/$/, "");            // "" ou "/es"
const PAGE = root.dataset.page || (location.origin + location.pathname); // link do plano (e-mails)
const KLAVIYO_ATIVO = root.dataset.klaviyo === "true";
// Preços na moeda escolhida pela cliente (seletor de país/moeda do cabeçalho); a loja já os envia convertidos.
const MOEDA = root.dataset.moeda || "EUR";
const formatoMoeda = new Intl.NumberFormat(lang === "es" ? "es-ES" : lang === "en" ? "en-GB" : "pt-PT", {style: "currency", currency: MOEDA});
const euro = n => formatoMoeda.format(n);
const ESTATISTICAS = root.dataset.estatisticas !== "false";
const PRIVACY_URL = ROOT + "/policies/privacy-policy";
const D = (await import(root.dataset.dados)).default;
const LOJA = JSON.parse(root.querySelector("[data-np-loja]").textContent);
["fios","agulhas","kits"].forEach(k=>{ LOJA[k] = LOJA[k] || {}; delete LOJA[k]._; });   // "_":0 fecha cada lista no Liquid
const app = root.querySelector("[data-np-app]");

const t = (k) => k.split(".").reduce((o,p)=>o&&o[p], T[lang]);
const VOC = {};
Object.values(D.vocabulario).forEach(arr=>arr.forEach(v=>{ VOC[v.pt]=v; }));
const tr = pt => lang==="pt" ? pt : ((VOC[pt]&&VOC[pt][lang]) || pt);

/* ---------- dados ao vivo da loja ---------- */
// No /es as opções vêm traduzidas; a posição do valor na lista dá o nome PT, que é o que as regras usam.
function ptOpts(h, lp, opts){
  const pt = (D.opcoes[h]||{}).pt || [];
  return opts.map((x,i)=>{ const loc = lp.o[i]||[], k = loc.indexOf(x);
    return (pt[i] && pt[i].length===loc.length && k>=0) ? pt[i][k] : x; });
}
const FIOS = D.fios.filter(f => LOJA.fios[f.handle]), KITS = D.kits;
const PROD = {}, KITP = {}, AGU = [];
FIOS.forEach(f=>{
  const lp = LOJA.fios[f.handle], o = D.opcoes[f.handle] || {};
  const single = [...new Set(f.bobines.map(b=>b.espessura))];
  PROD[f.handle] = {titulo: lp.t, url: lp.u, img: abs(lp.img), v: lp.v.map(([id, cents, disp, img, opts])=>{
    const pt = ptOpts(f.handle, lp, opts);
    const rest = opts.map((_,i)=>i).filter(i=>i!==o.im && i!==o.ib && opts[i] && opts[i]!=="Default Title");
    const fmtPt = o.ib!=null ? pt[o.ib] : (o.fmt || "Standard");
    return {id, preco: cents/100, disp, img: abs(img),
      esp: o.im!=null ? (normMm(pt[o.im]) || normMm(opts[o.im])) : (single.length===1 ? single[0] : null),
      fmt: fmtPt, fmtL: o.ib!=null ? opts[o.ib] : fmtPt,
      cor: rest.map(i=>opts[i]).join(" · ") || "Única", corPt: rest.map(i=>pt[i]).join(" · ") || "Única"};
  })};
});
Object.entries(LOJA.kits).forEach(([h,k])=>{ KITP[h] = {titulo:k.t, url:k.u, img:abs(k.img), preco:k.min/100, disp:k.av, n:k.n, id:k.id}; });
Object.entries(LOJA.agulhas).forEach(([h,lp])=>lp.v.forEach(([id, cents, disp, img, opts])=>{
  const n = mm(normMm(ptOpts(h, lp, opts)[0]) || normMm(opts[0]));
  if (!isNaN(n)) AGU.push({mm:n, id, preco:cents/100, disp, handle:h});
}));
const REG = D.regras || [], AREG = D.agulhaRegras || [];

/* ---------- utilidades ---------- */
const famCache = {};
function families(name, fallbackTitle){
  const key = name + "|" + (fallbackTitle||"");
  if (famCache[key]) return famCache[key];
  const words = norm(name === "Única" ? fallbackTitle : name);
  let out = Object.entries(FAM).filter(([id,f]) => f.k.some(k => new RegExp("\\b"+k+"\\b").test(words))).map(([id])=>id);
  if (!out.length) out = ["natural"];
  return famCache[key] = out;
}
const famV = (f, v) => families(v.corPt, f.nome);
function bobine(f, v){
  return f.bobines.find(b => b.espessura===v.esp && b.formato===v.fmt) || (f.bobines.length===1 ? f.bobines[0] : null);
}
function variants(f){            // variantes à venda e que podem ser sugeridas
  const p = PROD[f.handle]; if (!p) return [];
  return p.v.filter(v => v.disp && v.esp && (bobine(f,v)||{}).sugerir !== false);
}
const mmTxt = n => String(n).replace(".", ",") + "mm";
const rangeTxt = r => r.min===r.max ? mmTxt(r.min) : mmTxt(r.min).replace("mm","") + "–" + mmTxt(r.max);
function recFor(){
  const tec = A.tecnica; if (!tec || tec===UNSURE) return null;
  const own = A.peca && A.peca!==UNSURE && REG.find(r=>r.tecnica===tec && r.peca===A.peca);
  const gen = REG.find(r=>r.tecnica===tec && r.peca.startsWith("("));
  const r = own || gen; return r ? {...r, generic: !own} : null;
}
function hookFor(espStr){
  if (A.tecnica!=="Croché" || !AREG.length) return null;
  const x = mm(espStr);
  const r = AREG.reduce((b,r)=>Math.abs(r.fio-x)<Math.abs(b.fio-x)?r:b);
  return r.sem ? null : r;   // espessuras em que não se faz croché: sem agulha
}
function isPref(f){            // fio que a equipa pediu para sugerir nesta técnica + peça
  const r = recFor(); return !!(r && !r.generic && r.pref===f.handle);
}
function agulhaProd(n){
  const av = AGU.filter(a=>a.disp); if (!av.length) return null;
  return av.reduce((b,a)=>Math.abs(a.mm-n)<Math.abs(b.mm-n)?a:b);
}
const matsOf = f => MATS.filter(([_,test])=>test(f)).map(([m])=>m);

/* ---------- filtros ---------- */
const A = {};   // respostas
function passes(f, upto, relax=new Set()){
  const vs = variants(f); if (!vs.length) return false;
  const lim = upto==="fim" ? ORDER.length : ORDER.indexOf(upto);
  const on = k => ORDER.indexOf(k) < lim &&!relax.has(k) && A[k] && A[k]!==UNSURE && !(MULTI[k] && !A[k].length);
  if (on("tecnica") && !f.tecnicas.includes(A.tecnica)) return false;
  if (on("peca") && !f.pecas.includes(A.peca) && !isPref(f)) return false;
  if (on("uso") && A.uso==="Exterior" && !f.uso.includes("Exterior")) return false;
  if (on("material") && !matsOf(f).includes(A.material)) return false;
  if (on("esp") && !vs.some(v => Math.abs(mm(v.esp)-mm(A.esp)) <= 1)) return false;
  if (on("cores") && !vs.some(v => famV(f,v).some(x=>A.cores.includes(x)))) return false;
  return true;
}
const pool = upto => FIOS.filter(f => passes(f, upto));

function optionsFor(key){
  const P = pool(key), cnt = {};
  const add = x => cnt[x] = (cnt[x]||0)+1;
  if (key==="tecnica") P.forEach(f=>f.tecnicas.forEach(add));
  if (key==="peca") P.forEach(f=>f.pecas.forEach(add));
  if (key==="uso") { add("Interior"); if (P.some(f=>f.uso.includes("Exterior"))) add("Exterior"); }
  if (key==="caracts") P.forEach(f=>f.caracteristicas.filter(c=>c!=="Exterior (UV)").forEach(add));
  if (key==="material") P.forEach(f=>matsOf(f).forEach(add));
  if (key==="esp") P.forEach(f=>new Set(variants(f).map(v=>v.esp)).forEach(add));
  if (key==="cores") P.forEach(f=>new Set(variants(f).flatMap(v=>famV(f,v))).forEach(add));
  if (key==="nivel") ["Iniciante","Intermédio","Avançado"].forEach(add);
  let list = Object.keys(cnt);
  if (key==="esp") list.sort((a,b)=>mm(a)-mm(b));
  else if (key==="cores") list.sort((a,b)=>Object.keys(FAM).indexOf(a)-Object.keys(FAM).indexOf(b));
  else if (key==="uso"||key==="nivel") {}
  else list.sort((a,b)=>cnt[b]-cnt[a] || a.localeCompare(b));
  return list;
}

/* ---------- pontuação ---------- */
const RELAX_STEPS = [[],["cores"],["cores","esp"],["cores","esp","material"],["cores","esp","material","peca"],["cores","esp","material","peca","uso"]];
function recommend(){
  for (const r of RELAX_STEPS){
    const relax = new Set(r);
    const list = FIOS.filter(f => passes(f, "fim", relax));
    if (list.length) return {relax: r, list: list.map(f=>({f, ...score(f)})).sort((a,b)=>b.s-a.s)};
  }
  return {relax: [], list: []};
}
function score(f){
  let s = 0; const why = [];
  const vs = variants(f);
  if (A.peca && A.peca!==UNSURE && norm(f.nome).includes(norm(A.peca))) s+=2;
  if (A.peca && A.peca!==UNSURE && (f.pecas.includes(A.peca) || isPref(f))) { s+=10; why.push(fmt(t("why.peca"),{x:tr(A.peca).toLowerCase()})); }
  if (isPref(f)) { s+=8; why.unshift(t("why.pref")); }
  if (A.uso==="Exterior" && f.uso.includes("Exterior")) why.push(t("why.ext"));
  const cm = (A.caracts||[]).filter(c=>f.caracteristicas.includes(c));
  if (cm.length) { s += 3*cm.length; why.push(cm.map(tr).join(" · ")); }
  let espBest = null;
  if (A.esp && A.esp!==UNSURE){
    const exact = vs.some(v=>v.esp===A.esp);
    if (exact){ s+=4; espBest=A.esp; why.push(fmt(t("why.esp"),{x:A.esp})); }
    else {
      const near = [...new Set(vs.map(v=>v.esp))].sort((a,b)=>Math.abs(mm(a)-mm(A.esp))-Math.abs(mm(b)-mm(A.esp)))[0];
      if (near && Math.abs(mm(near)-mm(A.esp))<=1){ s+=1; why.push(fmt(t("why.espNear"),{x:near})); }
      espBest = near;
    }
  } else {
    const rec = recFor();
    if (rec){
      const es = [...new Set(vs.map(v=>v.esp))];
      const exact = es.find(e=>mm(e)===rec.def);
      const inr = es.filter(e=>mm(e)>=rec.min && mm(e)<=rec.max).sort((a,b)=>Math.abs(mm(a)-rec.def)-Math.abs(mm(b)-rec.def))[0];
      if (exact){ s+=3; espBest=exact; why.push(fmt(t("why.espRec"),{x:exact})); }
      else if (inr){ s+=2; espBest=inr; why.push(fmt(t("why.espRec"),{x:inr})); }
    }
  }
  if (A.cores && A.cores.length){
    const n = new Set(vs.filter(v=>famV(f,v).some(x=>A.cores.includes(x))).map(v=>v.cor)).size;
    if (n){ s+=2; why.push(n===1 ? t("why.cores1") : fmt(t("why.cores"),{n})); }
  }
  if (A.nivel==="Iniciante" && f.nivel.some(n=>n==="Todos"||n==="Iniciante")) s+=1;
  s += Math.min(new Set(vs.map(v=>v.cor)).size, 40)/40;   // desempate: mais cores disponíveis
  return {s, why, espBest};
}

/* ---------- render ---------- */
let stepIdx = 0, showN = 3, expanded = {}, primeiro = true, veioDeLink = false;
const steps = () => ORDER.filter(k => k!=="uso" || optionsFor("uso").length>1);
function topo(){   // depois de cada passo, volta ao início do planificador se ele saiu do ecrã
  if (primeiro){ primeiro = false; return; }
  if (root.getBoundingClientRect().top < 0) root.scrollIntoView({block:"start"});
}

function optLabel(key, v){
  if (v===UNSURE) return t("unsure");
  if (key==="cores") return FAM[v][lang];
  if (key==="esp") return v;
  return tr(v);
}
function render(){
  const S = steps();
  if (stepIdx >= S.length) return renderResults();
  const key = S[stepIdx]; let [title, sub] = t("q."+key);
  const rec = key==="esp" ? recFor() : null;
  if (rec) sub = rec.generic || !A.peca || A.peca===UNSURE
      ? fmt(t("recSubTec"),{tec:tr(A.tecnica),r:rangeTxt(rec)})
      : fmt(t("recSub"),{peca:tr(A.peca).toLowerCase(),tec:tr(A.tecnica).toLowerCase(),r:rangeTxt(rec)});
  const badge = v => { if (!rec || key!=="esp") return ""; const n=mm(v);
    return n===rec.def ? `<span class="np-badge np-badge--top">★ ${esc(t("recBadge"))}</span>` : (n>=rec.min && n<=rec.max ? `<span class="np-badge">${esc(t("inRange"))}</span>` : ""); };
  const cur = A[key];
  const allOpts = optionsFor(key), LIM = 12;
  const opts = (expanded[key] || allOpts.length <= LIM+2) ? allOpts : allOpts.slice(0, LIM).concat(allOpts.slice(LIM).filter(v => v===cur));
  const multi = !!MULTI[key];
  const sel = v => multi ? (cur||[]).includes(v) : cur===v;
  const unsureOpt = !["uso","nivel","caracts","cores"].includes(key);
  app.innerHTML = `
    <div class="np-progress"><i style="width:${(stepIdx)/S.length*100}%"></i></div>
    <div class="np-step">${fmt(t("step"),{n:stepIdx+1,t:S.length})}</div>
    <h2 class="np-title">${esc(title)}</h2><p class="np-sub">${esc(sub||"")}</p>
    <div class="np-opts" role="group" aria-label="${esc(title)}">
      ${opts.map(v=>`<button type="button" class="np-opt" data-v="${esc(v)}" aria-pressed="${sel(v)}">${key==="cores"?`<span class="np-dot" style="background:${FAM[v].c}"></span>`:""}<span>${esc(optLabel(key,v))}</span>${badge(v)}</button>`).join("")}
      ${opts.length<allOpts.length?`<button type="button" class="np-opt np-opt--unsure" data-np-more>+ ${esc(t("moreOpts"))} (${allOpts.length-opts.length})</button>`:""}
      ${unsureOpt?`<button type="button" class="np-opt np-opt--unsure" data-v="${UNSURE}" aria-pressed="${cur===UNSURE}">${esc(t("unsure"))}</button>`:""}
    </div>
    <div class="np-nav">
      ${stepIdx>0?`<button type="button" class="np-btn np-btn--ghost" data-np-back>← ${esc(t("back"))}</button>`:"<span></span>"}
      ${multi?`<button type="button" class="np-btn np-btn--primary" data-np-next>${esc((cur&&cur.length)?t("next"):t("skip"))}</button>`:""}
    </div>`;
  const mo = app.querySelector("[data-np-more]"); if (mo) mo.onclick=()=>{ expanded[key]=1; render(); };
  app.querySelectorAll(".np-opt[data-v]").forEach(b=>b.onclick=()=>{
    const v = b.dataset.v;
    if (multi){ const s=new Set(A[key]||[]); s.has(v)?s.delete(v):s.add(v); A[key]=[...s]; render(); }
    else { A[key]=v; clearAfter(key); stepIdx++; contar("Início", {}, true); render(); }
  });
  const bk = app.querySelector("[data-np-back]"); if (bk) bk.onclick=()=>{ stepIdx--; render(); };
  const nx = app.querySelector("[data-np-next]"); if (nx) nx.onclick=()=>{ A[key]=A[key]||[]; clearAfter(key); stepIdx++; contar("Início", {}, true); render(); };
  topo();
}
function clearAfter(key){   // respostas seguintes podem deixar de fazer sentido
  ORDER.slice(ORDER.indexOf(key)+1).forEach(k=>{
    if (A[k]===undefined) return;
    const ok = optionsFor(k);
    if (MULTI[k]) A[k] = (A[k]||[]).filter(v=>ok.includes(v));
    else if (A[k]!==UNSURE && !ok.includes(A[k])) delete A[k];
  });
}

function summaryChips(){
  return ORDER.filter(k=>A[k]!==undefined && A[k]!==UNSURE && !(MULTI[k]&&!A[k].length)).map(k=>{
    const v = MULTI[k] ? A[k].map(x=>optLabel(k,x)).join(", ") : optLabel(k,A[k]);
    return `<span class="np-chip"><b>${esc(t("ans."+k))}:</b> ${esc(v)}</span>`;
  }).join("");
}

const cardState = {};
function renderResults(){
  const {relax, list} = recommend();
  const relaxTxt = relax.map(k=>t("ans."+k).toLowerCase()).join(", ");
  app.innerHTML = `
    <div class="np-progress"><i style="width:100%"></i></div>
    <h2 class="np-title">${esc(t("resTitle"))}</h2><p class="np-sub">${esc(t("resSub"))}</p>
    <div class="np-summary">${summaryChips()}</div>
    ${recNote()}
    ${relax.length?`<p class="np-note">${esc(fmt(t("relaxed"),{x:relaxTxt}))}</p>`:""}
    ${list.length?"":`<p class="np-empty">${esc(t("nores"))}</p>`}
    <div data-np-cards></div>
    ${list.length>showN?`<button type="button" class="np-btn np-btn--ghost" data-np-showmore>${esc(t("more"))} (${list.length-showN})</button>`:""}
    <div data-np-kits></div>
    <div data-np-lead class="np-panel"></div>
    <div data-np-help class="np-panel"></div>
    <p class="np-meta np-calc">${esc(t("calc"))}</p>
    <div class="np-nav">
      <button type="button" class="np-btn np-btn--ghost" data-np-edit>← ${esc(t("edit"))}</button>
      <button type="button" class="np-btn np-btn--primary" data-np-restart>${esc(t("restart"))}</button>
    </div>`;
  const cards = app.querySelector("[data-np-cards]");
  list.slice(0, showN).forEach((r,i)=>cards.appendChild(card(r,i)));
  renderKits(); renderLead(list); renderHelp(list); saveHash();
  contar("Resultados", {origem: veioDeLink ? "link" : "quiz", sugestoes: list.length, ignorado: relax.join(", ") || null,
    sugestao_1: list[0] ? PROD[list[0].f.handle].titulo : null}, true);
  const more = app.querySelector("[data-np-showmore]"); if (more) more.onclick=()=>{ showN+=3; renderResults(); };
  app.querySelector("[data-np-edit]").onclick=()=>{ stepIdx=steps().length-1; render(); };
  app.querySelector("[data-np-restart]").onclick=()=>{ history.replaceState(null,"",location.pathname+location.search); leadDone=null; Object.keys(A).forEach(k=>delete A[k]); Object.keys(cardState).forEach(k=>delete cardState[k]); stepIdx=0; showN=3; render(); };
  topo();
}

function recNote(){
  const rec = recFor(); if (!rec) return "";
  const msg = (A.esp && A.esp!==UNSURE && (mm(A.esp)<rec.min || mm(A.esp)>rec.max))
    ? fmt(t("recDiff"),{x:A.esp, r:rangeTxt(rec)})
    : fmt(t("recBox"),{d:mmTxt(rec.def), r:rangeTxt(rec)});
  return `<p class="np-recbox">${esc(msg)}</p>`;
}
function card(r, i){
  const f = r.f, p = PROD[f.handle], vs = variants(f);
  const st = cardState[f.handle] || (cardState[f.handle] = {esp: r.espBest || null, fmt:null, cor:null, all:false, qty:1, metros:""});
  const esps = [...new Set(vs.map(v=>v.esp))].sort((a,b)=>mm(a)-mm(b));
  if (!esps.includes(st.esp)) st.esp = esps[0];
  const fmts = [...new Set(vs.filter(v=>v.esp===st.esp).map(v=>v.fmt))].sort((a,b)=>(a!=="Standard")-(b!=="Standard"));
  if (!fmts.includes(st.fmt)) st.fmt = fmts[0];
  const fmtLabel = x => (vs.find(v=>v.fmt===x)||{}).fmtL || x;
  const pool = vs.filter(v=>v.esp===st.esp && v.fmt===st.fmt);
  const wanted = (A.cores&&A.cores.length) ? pool.filter(v=>famV(f,v).some(x=>A.cores.includes(x))) : pool.slice(0, 16);
  let shown = (st.all || !wanted.length) ? pool : wanted;
  if (st.cor && !shown.some(x=>x.cor===st.cor) && pool.some(x=>x.cor===st.cor)) shown = shown.concat(pool.filter(x=>x.cor===st.cor));
  if (!pool.some(v=>v.cor===st.cor)) st.cor = (wanted[0]||pool[0]).cor;
  const v = pool.find(x=>x.cor===st.cor);
  const b = bobine(f, v) || {};
  if (st.metros && b.metros) st.qty = Math.max(1, Math.ceil(parseFloat(st.metros)*1.1 / b.metros));
  const rec = recFor();
  const hk = hookFor(st.esp), ag = hk && agulhaProd(hk.def);
  const hookTxt = hk && (hk.min===hk.max || hk.min==null ? mmTxt(hk.def) : mmTxt(hk.def) + " (" + rangeTxt(hk) + ")");

  const el = document.createElement("article"); el.className="np-card";
  el.innerHTML = `
    <img class="np-card__img" src="${esc(v.img||p.img||"")}" alt="${esc(p.titulo)}" loading="lazy" width="500" height="500">
    <div class="np-card__body">
      <span class="np-rank">#${i+1}</span>
      <h3 class="np-card__title">${esc(p.titulo)}</h3>
      <ul class="np-why">${r.why.map(w=>`<li>${esc(w)}</li>`).join("")}</ul>
      <div class="np-row">
        <label>${esc(t("esp"))} <select data-k="esp">${esps.map(e=>`<option value="${esc(e)}" ${e===st.esp?"selected":""}>${esc(e)}${rec&&mm(e)===rec.def?" ★":""}</option>`).join("")}</select></label>
        ${fmts.length>1?`<label>${esc(t("fmt"))} <select data-k="fmt">${fmts.map(e=>`<option value="${esc(e)}" ${e===st.fmt?"selected":""}>${esc(fmtLabel(e))}</option>`).join("")}</select></label>`:""}
      </div>
      <div class="np-meta">${esc(t("color"))}: <b>${esc(st.cor)}</b></div>
      <div class="np-colors">${shown.map(x=>`<button type="button" class="np-col" data-c="${esc(x.cor)}" aria-pressed="${x.cor===st.cor}"><span class="np-dot" style="background:${FAM[famV(f,x)[0]].c}"></span>${esc(x.cor)}</button>`).join("")}</div>
      ${wanted.length && wanted.length<pool.length?`<button type="button" class="np-link" data-k="all">${esc(st.all?t("seeLess"):fmt(t("seeAll"),{n:pool.length}))}</button>`:""}
      <div class="np-row np-row--price">
        <span class="np-price">${euro(v.preco)}</span>
        <span class="np-meta">${b.metros?esc(fmt(t("perBob"),{m:b.metros}))+" · "+esc(fmt(t("perM"),{p:euro(v.preco/b.metros)})):""}</span>
      </div>
      ${hk?`<div class="np-row np-hook"><span>🪡 ${esc(fmt(t("hook"),{r:hookTxt}))}</span>${ag?`<label><input type="checkbox" data-k="hook" ${st.hook?"checked":""}> ${esc(fmt(t("addHook"),{x:mmTxt(ag.mm),p:euro(ag.preco)}))}</label>`:""}</div>`:""}
      <div class="np-row">
        <label>${esc(t("meters"))} <input type="number" min="0" step="1" inputmode="numeric" data-k="metros" value="${esc(st.metros)}" placeholder="—"></label>
        <span class="np-meta">${esc(t("metersHint"))}</span>
      </div>
      <div class="np-actions">
        <div class="np-qty"><button type="button" data-k="minus" aria-label="-">−</button><span>${st.qty}</span><button type="button" data-k="plus" aria-label="+">+</button></div>
        <span class="np-meta">${esc(t("bobines"))}</span>
        <button type="button" class="np-btn np-btn--primary" data-k="add">${esc(t("add"))}</button>
        <a class="np-link" href="${esc(p.url)}?variant=${v.id}">${esc(t("view"))}</a>
      </div>
      <p class="np-err" data-k="err" hidden></p>
      <div class="np-opp" hidden></div>
    </div>`;
  const rerender = () => el.replaceWith(card(r,i));
  el.querySelectorAll("select").forEach(s=>s.onchange=()=>{ st[s.dataset.k]=s.value; rerender(); });
  el.querySelectorAll(".np-col").forEach(c=>c.onclick=()=>{ st.cor=c.dataset.c; rerender(); });
  const all = el.querySelector('[data-k="all"]'); if (all) all.onclick=()=>{ st.all=!st.all; rerender(); };
  el.querySelector('[data-k="minus"]').onclick=()=>{ st.metros=""; st.qty=Math.max(1,st.qty-1); rerender(); };
  el.querySelector('[data-k="plus"]').onclick=()=>{ st.metros=""; st.qty++; rerender(); };
  const hc = el.querySelector('[data-k="hook"]'); if (hc) hc.onchange=()=>{ st.hook=hc.checked; rerender(); };
  const mi = el.querySelector('[data-k="metros"]');
  mi.onchange=()=>{ st.metros=mi.value; rerender(); };
  const add = el.querySelector('[data-k="add"]');
  const origem = {_origem: "Planificador"};   // propriedade escondida no carrinho; aparece na encomenda
  add.onclick=()=>juntarAoCarrinho(add, el.querySelector('[data-k="err"]'),
    [{id: v.id, quantity: st.qty, properties: origem}].concat(st.hook && ag ? [{id: ag.id, quantity: 1, properties: origem}] : []),
    {fio: p.titulo, posicao: i+1, espessura: st.esp, cor: st.cor, bobines: st.qty, agulha: !!(st.hook && ag),
     $value: Math.round((v.preco*st.qty + (st.hook && ag ? ag.preco : 0))*100)/100});
  mostrarOpp(el.querySelector(".np-opp"), f, st.esp);
  return el;
}

/* ---------- estatísticas (Klaviyo › Analytics › Métricas, "Planificador — …") ----------
   Não identifica ninguém: sem cookies nem dados pessoais, todos os eventos vão para um único perfil técnico.
   Eventos: Início (1.ª resposta), Resultados, Adicionar ao carrinho ($value na moeda da cliente, ver "moeda"), Contacto (WhatsApp/e-mail). */
const nz = v => (v===undefined || v===UNSURE) ? null : v;
const contados = new Set();
function contar(nome, props = {}, umaVez = false){
  if (!ESTATISTICAS || (umaVez && contados.has(nome))) return;
  contados.add(nome);
  const properties = {...props, moeda: MOEDA, idioma: lang, tecnica: nz(A.tecnica), peca: nz(A.peca), nivel: nz(A.nivel)};
  fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO.empresa}`, {method: "POST", keepalive: true,
    headers: {"Content-Type": "application/vnd.api+json", "revision": KLAVIYO.revisao},
    body: JSON.stringify({data: {type: "event", attributes: {properties,
      metric: {data: {type: "metric", attributes: {name: "Planificador — " + nome}}},
      profile: {data: {type: "profile", attributes: {external_id: "navita-planificador-estatisticas"}}}}}})
  }).catch(() => {});
}

/* ---------- carrinho (igual ao botão do produto: atualiza o ícone e abre a gaveta do carrinho) ---------- */
async function juntarAoCarrinho(btn, errEl, items, estat){
  const txt = btn.textContent; btn.disabled = true; btn.textContent = t("adding"); errEl.hidden = true;
  const routes = (window.Theme && window.Theme.routes) || {};
  let ev = null; try { ev = await import("@shopify/events"); } catch (e) {}
  const Ev = ev && ev.CartLinesUpdateEvent;
  const deferred = Ev ? Ev.createPromise() : null;
  if (Ev) btn.dispatchEvent(new Ev({action: "add", context: "product",
    lines: items.map(i=>({merchandiseId: String(i.id), quantity: i.quantity})), promise: deferred.promise}));
  const sections = [...document.querySelectorAll("cart-items-component")].map(x=>x.dataset.sectionId).filter(Boolean);
  try {
    const res = await fetch(routes.cart_add_url || ROOT + "/cart/add.js", {method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify({items, sections: sections.join(",")})});
    const data = await res.json();
    if (!res.ok || data.status) throw Object.assign(new Error("cart/add " + res.status), {msg: data.description || data.message});
    const cart = await fetch((routes.cart_url || ROOT + "/cart") + ".js", {headers: {Accept: "application/json"}}).then(r=>r.json());
    if (deferred) deferred.resolve({cart: Ev.createCartFromAjaxResponse(cart),
      detail: {items: cart.items, source: "navita-planificador", sections: data.sections, didError: false}});
    btn.textContent = t("added");
    contar("Adicionar ao carrinho", estat);
    setTimeout(()=>{ btn.textContent = txt; btn.disabled = false; }, 2500);
  } catch (e) {
    console.error("Planificador:", e);
    if (deferred) deferred.reject(e);
    errEl.textContent = e.msg || t("addErr"); errEl.hidden = false;
    btn.textContent = txt; btn.disabled = false;
  }
}

/* ---------- plano: link, e-mail (Klaviyo) e contacto ---------- */
function saveHash(){
  const q = new URLSearchParams();
  ORDER.forEach(k=>{ if (A[k]!==undefined) q.set(k, MULTI[k] ? A[k].join("|") : A[k]); });
  history.replaceState(null, "", "#" + q.toString());
  return q.toString();
}
function loadHash(){
  const h = location.hash.slice(1); if (!h) return;
  const q = new URLSearchParams(h);
  let any = false;
  ORDER.forEach(k=>{ if (q.has(k)){ any = true; const v = q.get(k); A[k] = MULTI[k] ? (v ? v.split("|") : []) : v; }});
  if (any){ stepIdx = 99; veioDeLink = true; }
}
function answersLine(){
  return ORDER.filter(k=>A[k]!==undefined && A[k]!==UNSURE && !(MULTI[k]&&!A[k].length))
    .map(k => MULTI[k] ? A[k].map(x=>optLabel(k,x)).join(", ") : optLabel(k,A[k])).join(" · ");
}
function sugestoes(list){
  return list.slice(0, showN).map(r=>{ const st = cardState[r.f.handle] || {}, p = PROD[r.f.handle];
    const v = p.v.find(x=>x.esp===st.esp && x.fmt===st.fmt && x.cor===st.cor);
    return {nome: p.titulo, espessura: st.esp || null, cor: st.cor || null, img: (v && v.img) || p.img || null,
            url: location.origin + p.url + (v ? `?variant=${v.id}` : "")}; });
}
function planText(list){
  return [t("waIntro"), fmt(t("waAns"),{x:answersLine()}), "", t("waSug"),
    ...sugestoes(list).map(s=>`• ${s.nome}${s.espessura?" "+s.espessura:""}${s.cor?" ("+s.cor+")":""}`), "", t("waQ"), ""].join("\n");
}
let leadDone = null;
// Um só pedido: inscreve na lista (dispara o fluxo "O teu plano") e grava as respostas no perfil ao mesmo tempo.
// Com dois pedidos separados (perfil + inscrição), o Klaviyo processava a inscrição primeiro e o 1.º e-mail
// saía sem as sugestões (visto a 21/10/2026). A barra no fim do endereço é obrigatória (sem ela o navegador bloqueia por CORS).
async function enviarKlaviyo(email, properties){
  const r = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO.empresa}`, {method: "POST",
    headers: {"Content-Type": "application/vnd.api+json", "revision": KLAVIYO.revisao},
    body: JSON.stringify({data: {type: "subscription",
      attributes: {custom_source: KLAVIYO.fonte, profile: {data: {type: "profile", attributes: {email, properties}}}},
      relationships: {list: {data: {type: "list", id: KLAVIYO.lista}}}}})});
  if (!r.ok) throw new Error("subscrição " + r.status);
}
function renderLead(list){
  const box = app.querySelector("[data-np-lead]");
  if (leadDone){
    box.innerHTML = `<h3 class="np-panel__title">${esc(t("leadTitle"))}</h3><p class="np-ok">${esc(fmt(t("leadOk"),{e:leadDone.email}))}</p>
      ${leadDone.teste?`<details><summary>${esc(t("leadTest"))}</summary><pre>${esc(JSON.stringify(leadDone.payload, null, 2))}</pre></details>`:""}`;
    return;
  }
  box.innerHTML = `<h3 class="np-panel__title">${esc(t("leadTitle"))}</h3><p>${esc(t("leadSub"))}</p>
    <form novalidate>
      <div class="np-leadrow"><input type="email" required autocomplete="email" placeholder="${esc(t("leadPh"))}" aria-label="${esc(t("leadPh"))}">
      <button class="np-btn np-btn--primary" type="submit">${esc(t("leadBtn"))}</button></div>
      <label class="np-consent"><input type="checkbox"> <span>${esc(t("consent"))} <a class="np-link" href="${PRIVACY_URL}" target="_blank" rel="noopener">${esc(t("privacy"))}</a></span></label>
      <p class="np-err" hidden></p>
    </form>`;
  const form = box.querySelector("form"), err = box.querySelector(".np-err");
  form.onsubmit = e => {
    e.preventDefault();
    const email = form.querySelector("input[type=email]").value.trim();
    const ok = form.querySelector("input[type=checkbox]").checked;
    err.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ err.textContent = t("errEmail"); err.hidden = false; return; }
    if (!ok){ err.textContent = t("errConsent"); err.hidden = false; return; }
    const sug = sugestoes(list);
    const link = `${PAGE}#${saveHash()}`;
    const payload = {   // o que é enviado à API de subscrições do Klaviyo (lista "Planificador de Projetos")
      email, lista: KLAVIYO.lista + " (Planificador de Projetos)", fonte: KLAVIYO.fonte,
      consentimento: {texto: t("consent"), data: new Date().toISOString()},
      properties: {
        planificador_tecnica: nz(A.tecnica), planificador_peca: nz(A.peca), planificador_uso: nz(A.uso),
        planificador_caracteristicas: A.caracts||[], planificador_material: nz(A.material), planificador_espessura: nz(A.esp),
        planificador_cores: A.cores||[], planificador_nivel: nz(A.nivel), planificador_idioma: lang,
        planificador_link: link, planificador_sugestoes: sug,
        planificador_resumo: answersLine()
      }
    };
    // campos simples (sugestão 1, 2 e 3), mais fáceis de usar nos e-mails do Klaviyo
    sug.slice(0,3).forEach((x,i)=>{
      payload.properties[`planificador_sugestao_${i+1}_nome`] = x.nome;
      payload.properties[`planificador_sugestao_${i+1}_detalhe`] = [x.espessura, x.cor].filter(Boolean).join(" · ");
      payload.properties[`planificador_sugestao_${i+1}_url`] = x.url;
      payload.properties[`planificador_sugestao_${i+1}_img`] = x.img;
    });
    const btn = form.querySelector("button[type=submit]");
    if (!KLAVIYO_ATIVO){ console.log("Klaviyo (desligado):", payload); leadDone = {email, payload, teste: true}; renderLead(list); return; }
    btn.disabled = true;
    enviarKlaviyo(email, payload.properties)
      .then(() => { leadDone = {email, payload}; renderLead(list); })
      .catch(e => { console.error("Klaviyo:", e); err.textContent = t("errSend"); err.hidden = false; btn.disabled = false; });
  };
}
function renderHelp(list){
  const box = app.querySelector("[data-np-help]");
  box.innerHTML = `<h3 class="np-panel__title">${esc(t("helpTitle"))}</h3><p>${esc(t("helpSub"))}</p>
    <div class="np-contacts">
      <a class="np-btn np-btn--wa" target="_blank" rel="noopener" href="https://wa.me/${WHATSAPP}">WhatsApp</a>
      <a class="np-btn np-btn--outline" href="mailto:${EMAIL}">${esc(EMAIL)}</a>
    </div>`;
  // a mensagem é montada no clique, para levar a espessura e a cor escolhidas em cada cartão
  const wa = box.querySelector(".np-btn--wa"), ml = box.querySelector(".np-btn--outline");
  const upd = () => {
    const txt = planText(list);
    wa.href = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(txt)}`;
    ml.href = `mailto:${EMAIL}?subject=${encodeURIComponent(t("mailSubj"))}&body=${encodeURIComponent(txt)}`;
  };
  upd(); ["mousedown","focus","touchstart"].forEach(ev=>{ wa.addEventListener(ev, upd); ml.addEventListener(ev, upd); });
  wa.addEventListener("click", () => contar("Contacto", {canal: "WhatsApp"}));
  ml.addEventListener("click", () => contar("Contacto", {canal: "E-mail"}));
}

/* ---------- oportunidades: candidatas nos dados, preço e stock confirmados ao vivo ---------- */
const oppCache = {};
function oppLive(h){
  return oppCache[h] || (oppCache[h] = fetch(`${ROOT}/products/${h}.js`, {headers: {Accept: "application/json"}})
    .then(r => r.ok ? r.json() : null).then(p => {
      const v = p && p.variants.find(x=>x.available);
      return v ? {titulo: p.title.replace(/\[OPORTUNIDADE?\]/i, "").trim(), preco: v.price/100, url: p.url || `${ROOT}/products/${h}`} : null;
    }).catch(() => null));
}
function oppCandidatas(f, esp){
  const words = norm(f.nome).replace(/\b(100%|com|sem|alma|de|\d+(\.\d+)?mm)\b/g," ").split(/\s+/).filter(Boolean).slice(0,2).join(" ");
  if (!words) return [];
  return (D.opps||[]).filter(o => o.esp===esp && norm(o.titulo).includes(words) &&
    (!A.cores || !A.cores.length || families(o.titulo).some(x=>A.cores.includes(x))));
}
async function mostrarOpp(box, f, esp){
  for (const o of oppCandidatas(f, esp).slice(0, 3)){
    const live = await oppLive(o.handle);
    if (!live) continue;
    box.innerHTML = `<b>${esc(t("oppTxt"))}:</b> <a class="np-link" href="${esc(live.url)}">${esc(fmt(t("oppMsg"),{t:live.titulo,p:euro(live.preco)}))}</a>`;
    box.hidden = false; return;
  }
}

function renderKits(){
  if (A.nivel!=="Iniciante") return;
  const tec = A.tecnica && A.tecnica!==UNSURE ? A.tecnica : null;
  const pec = A.peca && A.peca!==UNSURE ? A.peca : null;
  const ok = k => KITP[k.handle] && KITP[k.handle].disp && k.nivel.some(n=>n==="Iniciante"||n==="Todos") && (!tec || k.tecnicas.includes(tec));
  let list = KITS.filter(k => ok(k) && pec && k.pecas.includes(pec));
  if (!list.length) list = KITS.filter(ok);
  list = list.slice(0,3);
  if (!list.length) return;
  app.querySelector("[data-np-kits]").innerHTML = `<h3 class="np-section">${esc(t("kitsTitle"))}</h3>
    <div class="np-kits">${list.map(k=>{ const p=KITP[k.handle]; return `
      <div class="np-kit"><img src="${esc(p.img||"")}" alt="${esc(p.titulo)}" loading="lazy" width="500" height="500"><div>
        <b>${esc(p.titulo)}</b>
        <span class="np-meta">${p.n>1?esc(t("from"))+" ":""}${euro(p.preco)}</span>
        ${k.nota_cliente?`<span class="np-meta">${esc(k.nota_cliente)}</span>`:""}
        <a class="np-btn np-btn--primary" href="${esc(p.url)}">${esc(t("kitBtn"))}</a>
      </div></div>`;}).join("")}</div>`;
}

loadHash(); render();
}
